



// 



import { Component, EventEmitter } from '@angular/core';
import { fadeInOut } from '../../services/animations';
import { ConfigurationService } from '../../services/configuration.service';
import { CreateEditQuoteModalComponent } from './create-edit-quote-modal/create-edit-quote-modal.component';
import { MatDialog } from '@angular/material';
import * as _ from 'lodash';
import { ApiService } from '../../services/api.service';
import { ViewQuoteModalComponent } from './view-quote-modal/view-quote-modal.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'quote-home',
    template: require('./quote-home.component.html'),
    styles: [require('./quote-home.component.css')],
    animations: [fadeInOut]
})
export class QuoteHomeComponent {
    quotes = [];
    public static QuotesChanged: EventEmitter<any> = new EventEmitter<any>();
    constructor(public configurations: ConfigurationService, public dialog: MatDialog, private apiService: ApiService, private spinner: NgxSpinnerService) {
        this.getQuotes();
        QuoteHomeComponent.QuotesChanged.subscribe(q =>
        {
            if (q) {
                //_.each(this.quotes, i =>
                //{
                //    if (i.quoteId == q.quoteId) {
                //        //this.getQuotes();
                //        i = q;

                //        this.generateDocx(i);
                //    }
                //});
                for (var i = 0; i < this.quotes.length; i++) {
                    if (this.quotes[i].quoteId == q.quoteId) {
                        this.quotes[i] = q;
                        this.generateDocx(this.quotes[i]);
                        return;
                    }
                }
            }

        });
    }

    

    getQuotes() {
        this.apiService.getQuotes().subscribe(r => {
            this.quotes = r;
            console.log(r)
        })
    }

    newQuote(service?: any) {
        let dialogRef = this.dialog.open(CreateEditQuoteModalComponent, {
            panelClass: "col-md-12",
            data: {
                currentQuote: {
                   customer : {} as any,
                    contracts : [],
                   quoteBenefits : []
                },
                //vendors: this.Services
            }
        });

        dialogRef.afterClosed().subscribe(r => {
            if (r) {
                this.getQuotes();
            }
        })
    }

    viewQuote(quoteId: any) {
        this.spinner.show();
        this.apiService.getQuote(quoteId).subscribe(r => {
            this.spinner.hide();
           let dialogRef = this.dialog.open(ViewQuoteModalComponent, {
               panelClass: "col-md-12",
               data: {
                   currentQuote: r,
                   //vendors: this.Services
               }
           });

           dialogRef.afterClosed().subscribe(r => {
               //this.getServices();
           })
       })


    }

    editQuote(q) {
        this.spinner.show();
        this.apiService.getQuote(q.quoteId).subscribe(r => {
            this.spinner.hide();
            let dialogRef = this.dialog.open(CreateEditQuoteModalComponent, {
                panelClass: "col-md-12",
                data: {
                    currentQuote: r,
                    //vendors: this.Services
                }
            });

            dialogRef.afterClosed().subscribe(r => {
                if (r) {
                    //this.getQuotes();
                }
            })
        })


    }

    generateDocx(q) {
        q.generatingDoc = true;
        this.apiService.generateDocx(q.quoteId).subscribe(r =>
        {
            q.generatingDoc = false;
            q.generatedDoc = r.link;
         })
    }

    generateDocxContract(c) {
        c.generatingDocContract = true;
        this.apiService.generateDocxContract(c.contractId).subscribe(r =>
        {
            c.generatingDocContract = false;
            c.generatedContractPath = r.link;
         })
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/quote-home/quote-home.component.ts